import * as _ from 'underscore';
import { SelectClickable } from './selectClickable';
import { Event } from '..';
import { IEvent } from '../../interfaces';
import { ISelectClickableCollectionEvent } from '../../events';
import { SelectClickableCollectionOptions } from '../../interfaces/options';

export class SelectClickableCollection<T extends SelectClickable> {
	private items: KnockoutObservableArray<T>;
	public selectedItem: T;
	private onSelect: Event<ISelectClickableCollectionEvent<T>>;
	private subscriptions: KnockoutSubscription[];
	public isLoading: KnockoutObservable<boolean>;
	public template: KnockoutObservable<string>;

	public get Selected(): IEvent<ISelectClickableCollectionEvent<T>> {
		return this.onSelect;
	}

	constructor(options: SelectClickableCollectionOptions<T>) {
		this.init(options);
	}

	public init(options: SelectClickableCollectionOptions<T>) {
		this.template = ko.observable<string>(options.template);
		this.onSelect = new Event<ISelectClickableCollectionEvent<T>>();
		this.items = ko.isObservable(options.items)
			? <KnockoutObservableArray<T>>options.items
			: ko.observableArray(<T[]>options.items);
		this.selectedItem = null;
		this.subscriptions = [];

		this.isLoading = ko.observable(false);
		this.bind();
	}

	public push(item: T) {
		this.items.push(item);
		this.subscribe(item);
	}

	private bind() {
		this.items().forEach(item => this.subscribe(item));
	}

	private subscribe(item: T) {
		if (item.isSelected()) {
			this.selectedItem = item;
		}

		//TODO delete old callBack concept - move to Event<T>
		this.subscriptions.push(
			item.isSelected.subscribe(isSelected => {
				if (isSelected) {
					this.deselect();
					this.selectedItem = item;
				} else {
					this.selectedItem = null;
				}
			})
		);

		item.Selected.subscribe(isSelected => {
			this.onSelect.notify(<ISelectClickableCollectionEvent<T>>{
				id: item.id,
				isSelected: isSelected,
				item: item
			});
		});
	}

	public getItemById(id: string): T {
		return _.find(this.items(), item => {
			return item.id == id;
		});
	}

	public setSelected(id: string, isSelected: boolean = true): T {
		var item: T;
		if ((item = this.getItemById(id))) {
			item.setSelected(isSelected);
		}
		return item;
	}

	public setItems(items: T[]) {
		this.clear();
		this.items(items);
		this.bind();
	}

	public deselect(): void {
		if (this.selectedItem) {
			this.selectedItem.setSelected(false);
		}
	}

	public clear() {
		this.unsubscribeAll();
		this.selectedItem = null;
		this.items.removeAll();
	}

	private unsubscribeAll() {
		this.subscriptions.forEach(subscription => subscription.dispose());
		this.subscriptions = [];
	}
}
